const _discourseRole = {
  AUTHOR: 'Author',
  STAKEHOLDER: 'Stakeholder',
  HOST: 'Chairperson',
};

export default Object.freeze(_discourseRole);
